import gql from 'graphql-tag'

export const gqlTermo = gql`
  {
    buscarTermo {
      url
    }
    buscarTermoPrivacidade {
      url
      tipoTermo
    }
    buscarManualDoUsuario {
      url
      tipoTermo
    }
  }
`



// WEBPACK FOOTER //
// ./src/alelo-logic/services/queries/term.js